import { useEffect } from "react";
import { Navigate } from "react-router";
import { Box, Typography } from "@mui/material";
import { useUser } from "@accredo/fe-shared/hooks/user.js";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import BankAccountTable from "../../components/tables/BankAccountTable.jsx";

/**
 * Bankkonten-Selbstverwaltung für Kunden mit der Rolle kd_verwaltung
 * (ACC-323-Folgeticket) - dieselbe Tabelle wie im admin-seitigen
 * Bankkonten-Tab (CustomerShowPage.jsx), aber ohne Kundenauswahl fest auf den
 * eigenen Kunden (user.kunde) beschränkt.
 */
export default function BankAccountsPage() {
  const { user } = useUser();
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Bankkonten", path: "/bankkonten" },
    ]);
  }, [setBreadcrumbs]);

  // Seite ist nur für kd_verwaltung zugänglich (Backend beschränkt die
  // zugehörigen Endpunkte über BankAccountPolicy ebenfalls auf sysadmin/den
  // eigenen Kunden).
  if (!user?.role_names?.includes("kd_verwaltung")) {
    return <Navigate to="/home" replace />;
  }

  if (!user?.kunde?.id) {
    return (
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Bankkonten
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Ihrem Benutzerkonto ist kein Kunde zugeordnet.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Bankkonten
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Hier können Sie Ihre Bankkonten verwalten.
        </Typography>
      </Box>
      <BankAccountTable scope="customer" customerId={user.kunde.id} />
    </>
  );
}
